<div class="card">
  <div class="card-body">
    <p class="card-title font-weight-bold">{{title}}</p>
    <p class="card-subtitle text-muted">Laden Sie eine {{fileName}} Datei hoch.</p>

    <input
      id="fileSelect"
      class="form-control-file"
      type="file"
      (change)="fileSelected($event)"
      [disabled]="isLoading()"
    >

    <ng-container *ngIf="allowReplace">
      <div class="checkbox-wrapper">
          <input type="checkbox" [id]="'raplceCheckbox_' + title" [(ngModel)]="replace">
          <label [for]="'raplceCheckbox_' + title" class="checkbox-label">
            Ersetzen
          </label>
          <fa-icon class="text-muted" [icon]="faInfoCircle" placement="top" [ngbTooltip]="'Die bestehenden ' + title + ' werden vor dem Importieren gelöscht.'"></fa-icon>
      </div>
    </ng-container>

    <div class="button-upload-wrapper">
      <button
        class="btn btn-sm btn-primary"
        id="uploadButton"
        [disabled]="isLoading() || file == null"
        (click)="upload()"
      >
        Hochladen
      </button>
      <div class="spinner-border text-primary activity-accessory" *ngIf="isLoading()">
        <span class="sr-only">Laden...</span>
      </div>
      <fa-icon
        class="text-danger activity-accessory"
        [icon]="faExclamationCircle"
        *ngIf="isError()"
      ></fa-icon>
      <fa-icon
        class="text-success activity-accessory"
        [icon]="faCheck"
        *ngIf="isSuccess()"
      ></fa-icon>
    </div>
  </div>
</div>
